import { DropdownV2 } from '@makyoapp/makyo-ui'

import { useGridV2Context } from '../../contexts/GridV2Context'
import { GridHeaderMenu } from './GridHeaderMenu'

export const GridColumnMenu = () => {
  const { gridModal, handleCloseMenu } = useGridV2Context()

  if (!gridModal || !gridModal?.isOpen) {
    return null
  }

  return (
    <DropdownV2 open={gridModal?.isOpen} onOpenChange={handleCloseMenu}>
      <DropdownV2.Trigger asChild>
        {gridModal.bounds && (
          <div
            className='fixed z-300'
            style={{
              left: gridModal.bounds.x,
              top: gridModal.bounds.y,
              width: gridModal.bounds.width,
              height: gridModal.bounds.height,
            }}
          />
        )}
      </DropdownV2.Trigger>

      <DropdownV2.Content
        side='right'
        align='start'
        className='text-m-m w-fit'
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {gridModal.column && <GridHeaderMenu activeColumn={gridModal.column} />}
      </DropdownV2.Content>
    </DropdownV2>
  )
}
